import textServices from 'services/text-services'
import { formatDate } from '../utils/formatDate'
import Status from './States'

interface IPrize {
  item?: any
  setShowDetails: (arg0: any) => void
  productExchangeCoupon?: any
  timeResult?: any
}

const Prize = ({ item, setShowDetails, productExchangeCoupon, timeResult }: IPrize) => {
  const setDetails = () => {
    setShowDetails(item)
  }

  return (
    <section className="profile__prizes__item cursor-pointer" onClick={setDetails}>
      <div className="profile__prizes__item__container__detail">
        <button className="profile__prizes__item__container__text__detail">
          Ver detalle
        </button>
      </div>
      <div className="profile__prizes__item__container">
        <div className="profile__prizes__item__container__img">
          <img src={item?.imageUrl} alt="Premio" />
        </div>
        <div className="profile__prizes__item__container__text">
          <h2 className="profile__prizes__item__container__text__title">{item?.title}</h2>
          <p className="profile__prizes__item__container__text__date">{item?.costInPoints > 0 ? 'Canjeado' : 'Ganado'} {formatDate(item?.exchangeAt)}</p>
          <Status status={item?.orderStatus} />
          <div className="profile__prizes__item__container__btn">
            {(item?.orderStatus === 6 || item?.temporalCouponExpiresAt) && (
              <button
                onClick={() => {
                  if (item?.orderStatus === 6 || timeResult(item?.temporalCouponExpiresAt)) {
                    productExchangeCoupon(item)
                  }
                }}
                className={`profile__prizes__item__container__btn__btn-main ${
                  item?.orderStatus === 6 ? 'profile__history__button__active' : ''
                } ${timeResult(item?.temporalCouponExpiresAt) ? 'profile__history__button__progress' : ''} ${
                  item?.orderStatus === 7 && !timeResult(item?.temporalCouponExpiresAt) ? '' : ''
                }`}
                disabled={item?.orderStatus === 7 && !timeResult(item?.temporalCouponExpiresAt)}
              >
                {item?.orderStatus === 6 &&
                  textServices.findByText('profile/coupon/activate', { es: 'Activar', en: 'ACTIVATE' })}
                {timeResult(item?.temporalCouponExpiresAt) &&
                  textServices.findByText('profile/coupon/active', {
                    es: 'Ver cupón activo',
                    en: 'View coupon active'
                  })}
                {item?.orderStatus === 7 &&
                  !timeResult(item?.temporalCouponExpiresAt) &&
                  textServices.findByText('profile/coupon/used', { es: 'Cupón usado', en: 'Coupon used' })}
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Prize
